import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { DetailsSuccessModal } from '@shared/components/details-success-modal/details-success-modal.component';
import { RequestApprovalModalComponent } from '@shared/components/request-approval-modal/request-approval-modal.component';
import { Column } from '@shared/models/column-interface';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-access-table',
  templateUrl: './access-table.component.html',
  styleUrls: ['./access-table.component.scss']
})
export class AccessTableComponent<T> implements OnInit {

  globalConstants = GlobalConstants;
  @Input()
  tableColumns: Array<Column> = [];

  @Input()
  tableData: Array<T> = [];

  @Input()
  tableId: any;

  @Input() personId: any;

  className!: string;
  bsModalRef!: BsModalRef;
  accessRequestSubmitSubscription!: Subscription;
  @ViewChild('accessTableSort') accessTableSort = new MatSort();
  displayedColumns: Array<string> = [];
  dataSource: MatTableDataSource<T> = new MatTableDataSource();

  constructor(private modalService: BsModalService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.displayedColumns = this.tableColumns.map((c) => c.columnDef);
    this.dataSource = new MatTableDataSource(this.tableData);
  }

  /** Track by function for ngFor in column iteration */
  trackByFn(index: number, disCol: any): number {
    return disCol.id;
  }

  /**Listen event for data changes */
  ngOnChanges() {
    this.displayedColumns = this.tableColumns.map((c) => c.columnDef);
    this.dataSource = new MatTableDataSource(this.tableData);
    this.dataSource.sort = this.accessTableSort;
  }

  /**After view loaded apply sort and clear functionlity */
  ngAfterViewInit() {
    this.accessTableSort.disableClear = true;
    this.dataSource.sort = this.accessTableSort;
  }
  checkEvent() {
  }

  /**Getting class for color differentiation based on request status */
  getClass(element: any) {
    this.className = ''
    switch (element) {
      case 'Approved':
        this.className = "text-green";
        break;
      case 'Pending':
        this.className = "text-orange";
        break;
      case 'Suspend':
        this.className = "text-grey";
        break;
      case 'Reject':
        this.className = "text-red";
        break;
      default:
        this.className = ''
    }
    return this.className
  }

  /** Update access button action discussion */
  updateAccess(actionType: any, status: any, accessData: any) {
    const modalData: any = {
      data: {
        'type': actionType,
        'status': status,
        'requestType': accessData?.requestType
      }
    }
    this.bsModalRef = this.modalService.show(RequestApprovalModalComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-lg modal-dialog-centered',
      initialState: modalData
    });
    this.bsModalRef.onHide?.subscribe((res) => { });

    this.bsModalRef.content.requestApprovalEvent.subscribe((data: any) => {
      this.submitAccessRequest(data?.type, status, accessData, data?.formData);
    });
  }

  /** Submit request for new/revoke/suspend/resume system access API implementation */
  submitAccessRequest(type: any, status: any, accessData: any, reason: any) {
    let selectedAppID: any = [];
    if (accessData?.appId) {
      selectedAppID.push(accessData?.appId)
    }

    let accessRequestData = {
      "personid": this.personId,
      "appIdSelected": selectedAppID,
      "statusId": this.globalConstants.WORKFLOW_REQUEST_CREATED,
      "appJustification": reason,
      "modifiedPersonid": 0,
      "requestTypeId": this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST
    }

    if (type === 'suspend') {
      accessRequestData['requestTypeId'] = this.globalConstants.WORKFLOW_SUSPEND_SYSTEM_ACCESS_REQUEST;
      accessRequestData['appJustification'] = reason.suspendReason;
    } else if (type === 'revoke') {
      accessRequestData['requestTypeId'] = this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST;
      accessRequestData['appJustification'] = reason.revokeReason;
    } else if (type = 'resume') {
      accessRequestData['requestTypeId'] = this.globalConstants.WORKFLOW_NEW_SYSTEM_ACCESS_REQUEST;
      accessRequestData['appJustification'] = reason.resumeReason;
    }

    this.accessRequestSubmitSubscription = this.commonService.submitSystemAccessRequest(accessRequestData, '').subscribe((accessSubmitResData: any) => {
      let modalData: any;
      if (type === 'suspend') {
        modalData = {
          data: {
            'data': 'success',
            'message': this.globalConstants?.SYSTEM_SUS_ACCESS_SUBMT_MSG,
            'subMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_APPR_MSG,
            'subSubMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_SUB_MSG,
            'status': 'submitData',
            'actionType': 'submitData'
          }
        };
      } else if (type === 'revoke') {
        modalData = {
          data: {
            'data': 'success',
            'message': this.globalConstants?.SYSTEM_REV_ACCESS_SUBMT_MSG,
            'subMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_APPR_MSG,
            'subSubMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_SUB_MSG,
            'status': 'submitData',
            'actionType': 'submitData'
          }
        };
      } else if (type === 'resume') {
        modalData = {
          data: {
            'data': 'success',
            'message': this.globalConstants?.SYSTEM_RES_ACCESS_SUBMT_MSG,
            'subMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_APPR_MSG,
            'subSubMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_SUB_MSG,
            'status': 'submitData',
            'actionType': 'submitData'
          }
        };
      }
      this.bsModalRef = this.modalService.show(DetailsSuccessModal, {
        animated: true,
        backdrop: 'static',
        class: 'modal-dialog modal-dialog-centered modal-dialog-sweet-alert',
        initialState: modalData
      })
      this.commonService.countChangeItemHandler(true);
      this.commonService.requestChangeItemHandler(true);
      this.commonService.accessChangeItemHandler(true);
    }, (error: any) => {
      const modalData: any = {
        data: {
          'data': 'error',
          'message': this.globalConstants?.SYSTEM_REV_ACCESS_ERR_MSG,
          'status': 'submitData',
          'actionType': 'submitData'
        }
      }
      if (type === 'suspend') {
        modalData.data.message = this.globalConstants?.SYSTEM_SUS_ACCESS_ERR_MSG;
      } else if (type === 'revoke') {
        modalData.data.message = this.globalConstants?.SYSTEM_REV_ACCESS_ERR_MSG;
      } else if (type === 'resume') {
        modalData.data.message = this.globalConstants?.SYSTEM_RES_ACCESS_ERR_MSG;
      }

      this.bsModalRef = this.modalService.show(DetailsSuccessModal, {
        animated: true,
        backdrop: 'static',
        class: 'modal-dialog modal-dialog-centered modal-dialog-sweet-alert',
        initialState: modalData
      });
    });
  }
}
